// import {useSelector} from "react-redux";
import React, {useState} from "react";
import {/*Badge,*/ Dropdown, /*DropdownItem as DropdownItemBootstrap,*/ DropdownMenu, DropdownToggle} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import {Envelope} from "react-bootstrap-icons";
// import {Link} from "react-router-dom";
// import {route} from "app/router/urls/routes";
import {formatDistance} from 'date-fns'

const messages = [
  {
    fullName: 'Albert Szulc',
    message: 'Dzień dobry',
    date: '2022-02-03T09:27:57.607Z',
  },
  {
    fullName: 'Marek Kaczmarek',
    message: 'Skończył się kabel',
    date: '2022-02-03T09:27:56.607Z',
  },
  {
    fullName: 'Przemysław Pietrzak',
    message: 'Jutro skończymy :)',
    date: '2022-02-03T09:27:55.607Z',
  },
]

export const Chats = () => {

  // const { conversations } = useSelector(({notification}) => notification);
  const [ isOpenDropdown, setIsOpen ] = useState(false);


  const handleToggleIsOpenDropdown = () => setIsOpen(!isOpenDropdown);

  return (
    <>
      <Dropdown
        isOpen={isOpenDropdown}
        toggle={handleToggleIsOpenDropdown}
        tag="li"
        className="dropdown-notification nav-item"
      >
        <DropdownToggle tag="a" className="nav-link nav-link-label">
          <Envelope size={21} />
          {/*{!!conversations?.unreadCount && (*/}
          {/*  <Badge pill color="primary" className="badge-up">*/}
          {/*    {` ${conversations.unreadCount} `}*/}
          {/*  </Badge>*/}
          {/*)}*/}
        </DropdownToggle>
        <DropdownMenu tag="ul" right className="dropdown-menu-media">
          <>
            <li className="dropdown-menu-header">
              <div className="dropdown-header mt-0">
                <span className="notification-title">Wiadomości</span>
              </div>
            </li>
            <PerfectScrollbar
              className="media-list overflow-hidden position-relative"
              options={{
                wheelPropagation: false
              }}
            >
              {messages.map(message => (
                <div className="message" key={message.date}>
                  <div>
                    <img src={`https://eu.ui-avatars.com/api/?name=${message.fullName}&background=436eb3&color=fff`} alt="" className="rounded-circle" width="40"/>
                  </div>
                  <div className="message__content">
                    <div className="d-flex justify-content-between">
                      <div className="font-weight-bold">{message.fullName}</div>
                      <div className="text-muted" style={{fontSize: '.75rem'}}>{formatDistance(new Date(message.date), new Date(), { addSuffix: true })}</div>
                    </div>
                    <div>{message.message}</div>
                  </div>
                </div>
              ))}
            </PerfectScrollbar>
            <li className="dropdown-menu-footer">
              {/*<DropdownItemBootstrap tag={Link} to={route['pc.conversations']} className="p-1 text-center">*/}
              {/*  <span className="align-middle">Zobacz wszystkie</span>*/}
              {/*</DropdownItemBootstrap>*/}
            </li>
          </>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};
